// extracted by mini-css-extract-plugin
export default {"TextInput":"TextInput_TextInput__knPHt","Label":"TextInput_Label__5KVg1"};